// @flow
import React, { forwardRef } from 'react';
import * as css from './Modal.module.css';

type PropsType = {
  terms: Object,
  isComviq: Boolean,
};

const RenderTerms = ({ terms, isComviq = false }: PropsType) => {
  return (
    <div className={css.content}>
      {terms.date}
      {terms.tableOfContent && (
        <>
          <div>
            <p className={css.subtitle}>{terms.intrductionTitle}</p>
            <p>{terms.introduction}</p>
          </div>
          <div>
            <p className={css.subtitle}>{terms.tableOfContent.title}</p>
            <ul className={css.list}>
              {terms.tableOfContent.sections.map((text, key) => (
                  <li key={key}>{text}</li>
              ))}
            </ul>
          </div>
        </>
      )}
      {terms.content.map((section, key) => (
        <>
          {!!section.title && <div key={key}>{section.title}</div>}
          {!!section &&
            section.terms.map((term, key) => {
              return (
                <div key={key}>
                  <p className={css.text}>
                    {isComviq ? (
                      <span className={css.subtitle}>{term.title} </span>
                    ) : (
                      <p className={css.subtitle}>{term.title}</p>
                    )}
                    {term.text}
                  </p>
                </div>
              );
            })}
        </>
      ))}
    </div>
  );
};

export default forwardRef(RenderTerms);
